import {
    CONTEXT_AJOUT_ARME_EN_MASSE_IMPORT,
    CONTEXT_CREER_COMPTE_ETAPE_IDENTITE,
    CONTEXT_EDITER_CEAF,
} from 'constants/apiUrls.constants';

const MESSAGE_ERREUR_500 =
    "Une erreur est survenue lors de l'appel au serveur. Merci de réessayer ultérieurement.";
const MESSAGE_ERREUR_COMPLEMENT =
    " Si l'erreur persiste, veuillez contacter votre préfecture de référence et lui communiquer ce code : ";
const MESSAGE_ERREUR_GENERATION_QRCODE =
    "Votre CEAF n'a pas pu être générée. Veuillez réessayer ultérieurement. ";

const ERREUR_AJOUT_ARME_EN_MASSE_MUSEE = 'ajout_arme_en_masse_detenteur_musee';

function alertesMiddleware(storeAPI) {
    return function wrapDispatch(next) {
        return function handleAction(action) {
            if (
                action.type &&
                (action.type.endsWith('HTTP_SUCCESS') || action.type.endsWith('HTTP_FAILURE'))
            ) {
                let type = 'success';
                let titre = 'Succès';
                let description = null;

                if (action.payload && action.payload.status) {
                    if (action.payload.data && action.payload.data.message) {
                        description = action.payload.data.message;
                    }
                    if (action.payload.status >= 400 && action.payload.status < 500) {
                        titre = 'Attention';
                        type = 'warning';

                        if (
                            action.payload.status === 422 &&
                            action.payload.data.message === ERREUR_AJOUT_ARME_EN_MASSE_MUSEE
                        ) {
                            description = action.payload.data.data
                                .map((item) => item.message)
                                .join('\n');
                        }
                        if (!description) {
                            description = MESSAGE_ERREUR_500;
                        }
                    }
                    if (action.payload.status >= 500) {
                        titre = 'Erreur';
                        type = 'error';
                        if (action.payload.data.message === MESSAGE_ERREUR_GENERATION_QRCODE) {
                            // afficher une desc personnalisée aux users dans ce cas
                            description = MESSAGE_ERREUR_GENERATION_QRCODE;
                        } else {
                            description = MESSAGE_ERREUR_500;
                        }
                    }
                }

                // Ajout du complément dans le message si erreur et si "x-correlation-id" présent dans le header.
                if (
                    action.payload &&
                    action.payload.status >= 400 &&
                    action.payload.headers['x-correlation-id'] &&
                    description &&
                    ![CONTEXT_EDITER_CEAF].includes(action.context) &&
                    ![CONTEXT_AJOUT_ARME_EN_MASSE_IMPORT].includes(action.context)
                ) {
                    description = `${description}\n${MESSAGE_ERREUR_COMPLEMENT}${action.payload.headers['x-correlation-id']}.`;
                }

                // Spécifique à la vérification du numéro de Licence.
                // Refacto
                if (
                    action.payload &&
                    action.payload.status === 404 &&
                    description.includes('Le numéro de Licence') &&
                    [CONTEXT_CREER_COMPTE_ETAPE_IDENTITE].includes(action.context)
                ) {
                    titre = 'Erreur : Numéro de licence invalide';
                    description = action.payload.data.message;
                }

                if (description) {
                    storeAPI.dispatch({
                        type: 'ALERTS_SHOW',
                        alerte: {
                            titre,
                            type,
                            description,
                        },
                    });
                }
            }
            return next(action);
        };
    };
}

export default alertesMiddleware;
